import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massRestoreBlogCategories } from "../../api/apiBlogCategories";
import parseError from "../../utils/parseError";

/**
 * Hook لاستعادة جماعية للتصنيفات
 */
export function useRestoreAllBlogCategories() {
    const queryClient = useQueryClient();

    const {
        mutate: restoreAllBlogCategoriesMutate,
        isPending,
    } = useMutation({
        mutationFn: massRestoreBlogCategories,
        onSuccess: (response) => {
            toast.success(response.message || "Restored successfully");
            queryClient.invalidateQueries({ queryKey: ["blog-categories"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore blog categories");
        },
    });

    return {
        restoreAllBlogCategoriesMutate,
        isPending,
    };
}
